<template>
  <div class="lp-presenters">
    <button
      v-for="(presenter, index) in presenters"
      :key="presenter._id || presenter.id || index"
      type="button"
      class="lp-presenter"
      @click="$emit('select', presenter)"
    >
      <lp-avatar class="lp-presenter-avatar" :name="presenter.name" :photo="presenter.photo" />
      <span class="lp-presenter-text">
        <span class="lp-presenter-name">{{ presenter.name }}</span>
        <span v-if="presenter.role" class="lp-presenter-role">{{ presenter.role }}</span>
      </span>
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
  </div>
</template>

<script>
import LpAvatar from './lp-avatar'

/**
 * Clickable presenter rows for a session detail drawer — avatar (photo when
 * the presenter has one, initials otherwise), name, role.
 *
 * Shared by the multiple-theme landing page (components/modals.blade.php) and
 * the registration page (pages/registration/index.vue) so both surfaces render
 * and behave identically. Selecting a row emits `select` with the presenter;
 * the host opens <lp-faculty-detail> with it.
 */
export default {
  name: 'lp-presenter-list',

  components: { LpAvatar },

  props: {
    presenters: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
.lp-presenters {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lp-presenter {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  background: var(--surface);
  border: 0.5px solid var(--border);
  border-radius: var(--radius-md);
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: var(--brand-light);
    background: var(--surface-alt);
  }

  svg {
    color: var(--text-tertiary);
    flex-shrink: 0;
  }
}

// Round/clipped/centred comes from <lp-avatar>; only the size is per-surface.
.lp-presenter-avatar {
  width: 36px;
  height: 36px;
  font-size: var(--fs-caption);
}

.lp-presenter-text {
  flex: 1;
  min-width: 0;
}

.lp-presenter-name {
  display: block;
  font-size: var(--fs-small);
  font-weight: 500;
  color: var(--text);
}

.lp-presenter-role {
  display: block;
  font-size: var(--fs-caption);
  color: var(--text-tertiary);
  margin-top: 1px;
}
</style>
